import entityReducer from "./portfolioEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
